
import React from 'react'
import ReactDOM from 'react-dom/client'


import Contact from './formulaire-contact/Contact'
const root = ReactDOM.createRoot(document.querySelector('.app-contact'))

root.render (
  <React.StrictMode>
    <Contact />
  </React.StrictMode>
)


/*
import Simulateur from './simulation-prix-metal/Simulateur'
const root = ReactDOM.createRoot(document.querySelector('.app-simulation'))

root.render (
  <React.StrictMode>
    <Simulateur />
  </React.StrictMode>
)

*/

/*
import Compositions from './compositions/Compositions'
const root = ReactDOM.createRoot(document.querySelector('.app-compositions'))

root.render (
  <React.StrictMode>
    <Compositions />
  </React.StrictMode>
)
*/